module.exports = __webpack_public_path__ + "static/img/qitafeiyongbaoxiao.40a426b0.png";